import { DoubleRightOutlined } from '@ant-design/icons';
import { Button, Input, PopConfirm, Table, message } from '@maxtropy/components';
import { Space } from 'antd';
import { ColumnsType } from 'antd/es/table';
import SectionTitle from '../SectionTitle';
import styles from './index.module.scss';

type DispatchStatus = 'pending' | 'expired' | 'issued';

interface DispatchRow {
  key: string;
  date: string;
  time: string;
  issuedValue: string;
  suggestedValue: string;
  actualValue?: string;
  status: DispatchStatus;
}

interface ValueStackProps {
  record: DispatchRow;
  editable?: boolean;
}

const deviceNames = [
  '1#电石炉',
  '2#电石炉',
  '3#电石炉',
  '4#电石炉',
  '5#电石炉',
  '6#电石炉',
  '1#硅铁炉',
  '2#硅铁炉',
  '3#硅铁炉',
  '4#硅铁炉',
  '5#硅铁炉',
  '6#硅铁炉',
];

const rows: DispatchRow[] = [
  {
    key: '15:00',
    date: '2026-07-02',
    time: '15:00',
    issuedValue: '800.37',
    suggestedValue: '800.37',
    status: 'pending',
  },
  {
    key: '14:55',
    date: '2026-07-02',
    time: '14:55',
    issuedValue: '631.28',
    suggestedValue: '1000.00',
    actualValue: '800.75',
    status: 'expired',
  },
  {
    key: '14:50',
    date: '2026-07-02',
    time: '14:50',
    issuedValue: '631.28',
    suggestedValue: '1000.00',
    actualValue: '800.75',
    status: 'issued',
  },
  {
    key: '14:45',
    date: '2026-07-02',
    time: '14:45',
    issuedValue: '631.28',
    suggestedValue: '1000.00',
    actualValue: '800.75',
    status: 'issued',
  },
  {
    key: '14:40',
    date: '2026-07-02',
    time: '14:40',
    issuedValue: '631.28',
    suggestedValue: '1000.00',
    actualValue: '800.75',
    status: 'issued',
  },
];

const ValueStack = ({ record, editable = false }: ValueStackProps) => (
  <div className={styles.valueStack}>
    {editable ? (
      <Input className={styles.dispatchInput} defaultValue={record.issuedValue} aria-label="下发值" />
    ) : (
      <span className={styles.issuedValue}>{record.issuedValue}</span>
    )}
    <span className={styles.suggestedValue}>{record.suggestedValue}</span>
    {record.actualValue && <span className={styles.actualValue}>{record.actualValue}</span>}
  </div>
);

const DispatchInstruction = () => {
  const confirmIssue = () => message.success('调度指令下发成功');

  const columns: ColumnsType<DispatchRow> = [
    {
      title: '时间',
      key: 'time',
      width: 108,
      fixed: 'left',
      render: (_, record) => (
        <div className={styles.timeCell}>
          <span>{record.date}</span>
          <span>{record.time}</span>
        </div>
      ),
    },
    ...deviceNames.map(name => ({
      title: `${name}(MW)`,
      key: name,
      width: 105,
      render: (_: unknown, record: DispatchRow) => (
        <ValueStack record={record} editable={record.status === 'pending'} />
      ),
    })),
    {
      title: '状态',
      key: 'status',
      width: 132,
      fixed: 'right',
      render: (_, record) => {
        if (record.status === 'pending') {
          return (
            <Space className={styles.rowActions} size={12}>
              <PopConfirm
                title="确认一次下发所有炉台的功率控制指令？"
                okText="确定"
                cancelText="取消"
                onConfirm={confirmIssue}
              >
                <Button type="link">确认下发</Button>
              </PopConfirm>
              <Button type="link">重置</Button>
            </Space>
          );
        }

        return (
          <Space className={styles.status} size={12}>
            <span className={record.status === 'expired' ? styles.expired : styles.issued}>
              {record.status === 'expired' ? '已过期-未下发' : '已下发'}
            </span>
          </Space>
        );
      },
    },
  ];

  return (
    <section className={styles.dispatchPanel}>
      <div className={styles.dispatchTitle}>
        <div className={styles.dispatchTitleLeft}>
          <SectionTitle>负荷侧调度指令</SectionTitle>
          <span className={styles.issuedLegend}>下发值</span>
          <span className={styles.suggestedLegend}>建议值</span>
          <span className={styles.actualLegend}>实际值</span>
        </div>
        <Button
          type="link"
          className={styles.operationRecordButton}
          href="/dispatch/control/load-center/operation-record"
          target="_blank"
          rel="noreferrer"
        >
          <span>负荷调度操作记录</span>
          <DoubleRightOutlined />
        </Button>
      </div>
      <Table rowKey="key" columns={columns} dataSource={rows} pagination={false} scroll={{ x: 1500 }} />
    </section>
  );
};

export default DispatchInstruction;
